import dayjs from 'dayjs'
import { Preferences } from '@capacitor/preferences'
import { apolloClient } from '@/vendor/apollo-client.ts'
import { BACKGROUND_OPERATION } from '@/utils/backgroundOperation'
import { RECORD_USER_ACTIVITY } from '@/queries/activity.ts'
import { isConnected } from '@/utils/connectivity.ts'

const LAST_ACTIVITY_PING_DAY_KEY = 'lastActivityPingDay'

export async function pingUserActivity(): Promise<void> {
  if (!isConnected()) {
    return
  }
  const today = dayjs().format('YYYY-MM-DD')
  const { value: lastPingedDay } = await Preferences.get({ key: LAST_ACTIVITY_PING_DAY_KEY })
  if (lastPingedDay === today) {
    return
  }
  try {
    const { data } = await apolloClient.mutate({
      mutation: RECORD_USER_ACTIVITY,
      context: BACKGROUND_OPERATION,
    })
    const recordedDay = data?.recordUserActivity
    if (recordedDay) {
      await Preferences.set({ key: LAST_ACTIVITY_PING_DAY_KEY, value: recordedDay })
    }
  } catch (error) {
    console.error('Recording user activity failed', error)
  }
}
